/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { ControlMessage } from './abstract-control-message';

export class DeviceInfoMessage extends ControlMessage {

  constructor(arrayBuffer?: ArrayBufferLike) {
    super(arrayBuffer);
    this.id = ControlMessage.ControlMessageIdentifier.DEVICE_IDENTIFICATION;
  }

}
